import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatErrorsDirective } from './directives/mat-errors.directive';
import { CustomDateAdapter } from './directives/custom-date-adapter';
import { CommonModule } from '@angular/common';
import { WindowRefService } from './utils/window-ref.service';
import { HeightEqualizerService } from './directives/height-equalizer/height-equalize.service';
import { AonUploadButtonComponent } from '../../utils/components/aon-upload-button/aon-upload-button.component';
import { SuccessDialogComponent } from './dialogs/success-dialog.component';
import { ErrorDialogComponent } from "./dialogs/error-dialog.component";
import { ConfirmDialogComponent } from "./dialogs/confirm-dialog.component";
import { SelectContextDialogComponent } from "./dialogs/select-context-dialog.component";
import { SelectFileDialogComponent } from "./dialogs/select-file-dialog.component";
import { AuthUtils } from './utils/auth.utils';
import {TextFieldModule} from "@angular/cdk/text-field";
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

/*
 * Here put all the shared directives, components and pipe
 * You should import this module in every module where you want to use these shared directives
 * */
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		MatDatepickerModule,
		MatCardModule,
		MatDialogModule,
		MatIconModule,
		MatInputModule,
		MatTableModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatIconModule,
		MatSlideToggleModule,
		MatSidenavModule,
		MatSelectModule,
		MatNativeDateModule,
		MatTabsModule,
		MatButtonModule,
		MatCheckboxModule,
		TextFieldModule,
		MatPaginatorModule,
		MatSortModule
	],
	declarations: [
		MatErrorsDirective,
		SuccessDialogComponent,
		ErrorDialogComponent,
		ConfirmDialogComponent,
		SelectContextDialogComponent,
		SelectFileDialogComponent,
		AonUploadButtonComponent
	],
	exports: [
		ReactiveFormsModule,
		FormsModule,
		TranslateModule,
		TooltipModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatDatepickerModule,
		MatCardModule,
		MatDialogModule,
		MatDividerModule,
		MatInputModule,
		MatListModule,
		MatTableModule,
		MatTabsModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatErrorsDirective,
		MatIconModule,
		MatSlideToggleModule,
		MatSidenavModule,
		MatSelectModule,
		AonUploadButtonComponent,
		MatNativeDateModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatSortModule
	],
	providers: [
		{ provide: DateAdapter, useClass: CustomDateAdapter },
		WindowRefService,
		HeightEqualizerService,
		AuthUtils,
	]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule
		};
	}

	constructor(private dateAdapter: DateAdapter<Date>) {
		dateAdapter.setLocale('en-GB');
	}
}
